export default __webpack_public_path__ + "static/media/1122.4de58649.png";